import { initializeFaro as initFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export function initializeFaro() {
  // Only enable if configured
  if (import.meta.env.VITE_FARO_ENABLED !== 'true') {
    console.log('[Faro] Frontend observability is DISABLED');
    return;
  }

  const faroUrl = import.meta.env.VITE_FARO_URL as string | undefined;
  if (!faroUrl) {
    console.warn('[Faro] VITE_FARO_URL not configured');
    return;
  }

  console.log('[Faro] Initializing Grafana Faro...');

  initFaro({
    url: faroUrl as string,
    app: {
      name: 'ams-client-v2',
      version: import.meta.env.VITE_APP_VERSION || '0.1.0',
      environment: import.meta.env.MODE || 'development',
    },
    instrumentations: [
      // Default web instrumentations (errors, logs, web vitals)
      ...getWebInstrumentations(),

      // Tracing instrumentation with backend propagation
      new TracingInstrumentation({
        instrumentationOptions: {
          // Propagate trace context to backend
          propagateTraceHeaderCorsUrls: [
            /localhost:3000/,  // Local development
            /ams-admin-v2-server\.amajormusic\.co\.uk/,  // Production
          ],
        },
      }),
    ],
  });

  console.log('[Faro] Frontend observability initialized successfully');
}
